(function () {

    var myObj = {
    };

    myObj.setClickActions = function () {
        document.querySelectorAll('[data-link="more-challenges"]').forEach(item => {
            item.addEventListener('click', function () {
                item.classList.add("hide");
                item.closest('[data-section="subtopic-challenges-section"]').querySelector('[data-link="less-challenges"]').classList.remove("hide");
                item.closest('[data-section="subtopic-challenges-section"]').querySelector('[data-section="collapsible"]').classList.remove("hide");
            });
        });

        document.querySelectorAll('[data-link="less-challenges"]').forEach(item => {
            item.addEventListener('click', function () {
                item.classList.add("hide");
                item.closest('[data-section="subtopic-challenges-section"]').querySelector('[data-link="more-challenges"]').classList.remove("hide");
                item.closest('[data-section="subtopic-challenges-section"]').querySelector('[data-section="collapsible"]').classList.add("hide");
            });
        });
    };

    myObj.init = function () {
        myObj.setClickActions();
    };

    //bind this to myObj is each function
    myObj.setClickActions = myObj.setClickActions.bind(myObj);
    myObj.init = myObj.init.bind(myObj);

    myObj.init();
})();